export default __webpack_public_path__ + "images/online-payment/maestro.svg?3356f1968ff5844236a60bcf13bd0d847c282fa0f51035f7047eb246996e3cdc";